import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectors } from '@yola/subscription-manager-js';
import user from 'src/js/modules/user';
import routersMap from 'src/js/router/helpers/routes-map';
import redirectToUrl from 'src/js/utils/redirect-to-url';

function InitiateUpgradeRoute() {
  const navigate = useNavigate();
  const upgradeUrl = useSelector(user.selectors.getUpgradeUrl);
  const upgradeExist = useSelector(selectors.getHostingUpgradeAvailability);
  const availablePlatformComponents = user.hooks.useAvailablePlatformComponents();

  useEffect(() => {
    if (!upgradeExist) {
      navigate(routersMap.home.url(), { replace: true });
    }

    if (availablePlatformComponents.includes(user.constants.platformComponents.PAYMENTS)) {
      navigate(
        routersMap.paywall.url({
          query: window.location.search,
        }),
        { replace: true }
      );
    } else if (upgradeUrl) {
      redirectToUrl(upgradeUrl);
    }
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default InitiateUpgradeRoute;
